import React, { useMemo, useContext } from 'react'
import { ChartOption, ChartOptionElement } from 'gqlTypes'
import { useRecoilValue } from 'recoil'
import { chartOptionAtom, keyForElementIdAndType } from 'recoil/settings'

export type ChartOptionsValue = Pick<
  ChartOption,
  'cohort' | 'subgroup' | 'pastResults' | 'config'
>

export type ChartOptionsContextProviderProps = {
  id: string
  reportId?: string
  type: ChartOptionElement
  children?: React.ReactNode
}

export const ChartOptionsContext = React.createContext<ChartOptionsValue>({})

export const ChartOptionsContextProvider: React.FC<
  ChartOptionsContextProviderProps
> = ({ id, type, children, reportId }) => {
  const parentValue = useContext(ChartOptionsContext)
  const settings = useRecoilValue(
    chartOptionAtom(keyForElementIdAndType({ id, type, reportId }))
  )

  const derivedSettings = useMemo(
    () => ({ ...parentValue, ...settings }),
    [settings, parentValue]
  )

  return (
    <ChartOptionsContext.Provider value={derivedSettings}>
      {children}
    </ChartOptionsContext.Provider>
  )
}
